export const CHANGE_STEP_FORM = "CHANGE_STEP_FORM";
export const RESERVACION = "STEP_RESERVACION";
export const VEHICULO = "STEP_VEHICULO";
export const COBERTURAS = "STEP_COBERTURAS";
export const DATOS_CLIENTE = "STEP_DATOS_CLIENTE";
export const CONFIRMACION = "STEP_CONFIRMACION";
export const COTIZAR = "STEP_COTIZAR";
export const FINAL = "STEP_FINAL";
export const RESET = "RESET";
export const CHANGE_TYPE_CAR = 'CHANGE_TYPE_CAR';
export const CHANGE_REDIRECT = 'CHANGE_REDIRECT';
export const CHANGE_RUTA_FORMULARIO = "CHANGE_RUTA_FORMULARIO";

export const STEPS = {
    RESERVACION,
    VEHICULO,
    COBERTURAS,
    DATOS_CLIENTE,
    CONFIRMACION,
    FINAL,
    COTIZAR
}

const TIPO_SUV = "SUV";
const TIPO_PICKUP = "PICKUP";
const TIPO_VAN = "VAN";
const TIPO_MINIVAN = "MINIVAN";
const TIPO_SEDAN = "SEDAN";

export const TIPO_VEHICULOS = {
    TIPO_SUV,
    TIPO_PICKUP,
    TIPO_VAN,
    TIPO_MINIVAN,
    TIPO_SEDAN
}

export const changeStepForm = step => {
    let boolRedirect = false;
    /* 
    if ((step.stepForm === STEPS.COBERTURAS) || (step.stepForm === STEPS.DATOS_CLIENTE)|| (step.stepForm === STEPS.CONFIRMACION)) {
        boolRedirect = true;
    }
    */
    boolRedirect = true;
    
    //console.log(boolRedirect);
    return {
        type: CHANGE_STEP_FORM,
        step,
        typeCar: 'sedan',
        redirect: boolRedirect
    }
}

export const reset = () => {
    return {
        type: RESET
    }
}


export const changeRutaFormulario = (stepWay) => {
    console.log("step wayu ", stepWay);
    return {
        type: CHANGE_RUTA_FORMULARIO,
        stepWay: stepWay
    }
}

export const changeTypeCar = (typeCar) => {
    return {
        type: CHANGE_TYPE_CAR,
        typeCar: typeCar,
        redirect: true
    }
}

export const changeTypeRedirect = (booleanRedirect) => {

    return {
        type: CHANGE_REDIRECT,
        redirect: booleanRedirect

    }
}